import http from '@/uteis/http'

export default class LocalidadeService {
  async getLocalidadeByCep (cep) {
    const url = `/d0593/pae-back/v1/localidades/${cep}`

    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
